export default (api) => ({
    list: (params) => api.get('/datasets/bpmn', { params }),
    create: ({ params }) => api.post('/datasets/bpmn', params),
    get: ({ modelId }) => api.get(`/datasets/bpmn/${modelId}`),
    delete: ({ modelId }) => api.delete(`/datasets/bpmn/${modelId}`),
    update: ({ modelId, params }) => api.put(`/datasets/bpmn/${modelId}`, params),

})
